/**
 * The occurrence-number chips.
 *
 * Two rules, both the old flow's: every space is stripped from a number, and the same number cannot
 * be added to one bulletin twice. A pure function for the reason `model/incidentTimes.ts` gives —
 * phase 3's schema has to agree with it.
 */
export const normalizeOccurrenceNumbers = (values: string[]): string[] =>
  values.reduce<string[]>((kept, value) => {
    const number = value.replace(/\s+/g, "");

    if (!number) return kept;
    // Case-insensitively, because that is how the duplicate lookup compares them — "PR26-1" and
    // "pr26-1" are one number, and keeping both would send two of the same to the payload.
    return kept.some(
      (existing) => existing.toLowerCase() === number.toLowerCase(),
    )
      ? kept
      : [...kept, number];
  }, []);
